// Level / rank system
import { getGameStats, getPuzzleStats } from './store';

export interface Level {
  name: string;
  icon: string;
  minPoints: number;
}

export const LEVELS: Level[] = [
  { name: 'Pawn', icon: '🥉', minPoints: 0 },
  { name: 'Knight', icon: '🥈', minPoints: 10 },
  { name: 'Bishop', icon: '🥇', minPoints: 30 },
  { name: 'Rook', icon: '🏆', minPoints: 60 },
  { name: 'Queen', icon: '👑', minPoints: 100 },
  { name: 'King', icon: '♔', minPoints: 150 },
];

// Points: Win=3, Draw=1, Loss=0, Puzzle solved=1
export async function calculatePoints(): Promise<number> {
  const gameStats = await getGameStats();
  const puzzleStats = await getPuzzleStats();

  return (gameStats.wins * 3) + (gameStats.draws * 1) + puzzleStats.solved;
}

export async function getCurrentLevel(): Promise<{ level: Level; points: number; nextLevel: Level | null }> {
  const points = await calculatePoints();

  let current = LEVELS[0];
  let next: Level | null = null;

  for (let i = LEVELS.length - 1; i >= 0; i--) {
    if (points >= LEVELS[i].minPoints) {
      current = LEVELS[i];
      next = i < LEVELS.length - 1 ? LEVELS[i + 1] : null;
      break;
    }
  }

  return { level: current, points, nextLevel: next };
}
